// Vuetify
import "@mdi/font/css/materialdesignicons.css"; // Ensure you are using css-loader
import "vuetify/styles";
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";

const vuetify = createVuetify({
  components,
  directives,
  icons: {
    defaultSet: "mdi", // This is already the default value - only for display purposes
  },
  theme: {
    themes: {
      light: {
        dark: false,
        colors: {
          primary: "rgba(241, 218, 65, 1)",
          secondary: "rgba(108, 189, 250, 1)",
          blueButton: "#0B6CDE",
          tertiary: "#FC9C4C",
          light: "#FCB061",
          smoke: "rgba(232, 232, 232, 1)",
          sun: "#FCE393",
          // Valsplat brand palette (mirrored from src/assets/styles/tokens.scss)
          vpBlack: "#141919",
          vpTurquoise: "#5FCAB6",
          vpGeel: "#E7C53E",
          vpRood: "#F05668",
          vpBlauw: "#3A74D0",
          vpGrijs10: "#F3F3F3",
          vpGrijs20: "#E7E8E8",
          vpGrijs120: "#727575",
          vpGrijs160: "#434747",
        },
      },
    },
  },
});

export default vuetify;
